import React from 'react';
import { Course } from 'redux/schemas/models/course';
import t from 'react-translate';
import GenericSearchInput, { SearchResultItemComponent } from './nv-search-input';

type CourseSearchInputProps = {
  fetchCoursePredictions: (hint: string) => Promise<Course[]> | Course[]
  SearchResultItem: SearchResultItemComponent<Course>;
  alwaysShowInput?: boolean;
  searchInputClassName?: string;
  searchInputExtraContent?: React.ReactNode;
  className?: string;
  placeholder?: string;
  autocompleteClassName?: string;
  deniedCoursesDictionary?: { [catalogId: string]: boolean };
  deniedTooltipText?: string
  addTooltipText?: string
  onSelectItem?: (item: Course) => void
  maxResults?: number
};

const CourseSearchInput = (props: CourseSearchInputProps) => {
  const {
    fetchCoursePredictions,
    className,
    placeholder,
    SearchResultItem,
    alwaysShowInput,
    searchInputClassName,
    searchInputExtraContent,
    onSelectItem,
    autocompleteClassName,
    deniedCoursesDictionary,
    addTooltipText,
    deniedTooltipText,
    maxResults,
  } = props;


  return (
    <GenericSearchInput<Course>
      fetchPredictions={fetchCoursePredictions}
      keyExtractor={(item) => item.catalogId}
      placeholder={placeholder}
      emptyResultsText={t.LEARNING_JOURNEYS.DETAILS.COURSES.EMPTY_RESULTS()}
      searchingText={t.LEARNING_JOURNEYS.DETAILS.COURSES.SEARCHING()}
      addTooltipText={addTooltipText}
      deniedTooltipText={deniedTooltipText}
      className={className}
      autocompleteClassName={autocompleteClassName}
      SearchResultItem={SearchResultItem}
      alwaysShowInput={alwaysShowInput}
      searchInputClassName={searchInputClassName}
      deniedItemsDictionary={deniedCoursesDictionary}
      searchInputExtraContent={searchInputExtraContent}
      onSelectItem={onSelectItem}
      maxResults={maxResults}
    />
  );
};

export default CourseSearchInput;
